'use client'

import i18next from './i18next'
import { useParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const runsOnServerSide = typeof window === 'undefined'

export function useT(ns: string, options?: any) {
  const locale = useParams()?.locale
  if (typeof locale !== 'string') throw new Error('useT is only available inside /app/[countryCode]/[locale] routes')
  if (runsOnServerSide && i18next.resolvedLanguage !== locale) {
    i18next.changeLanguage(locale)
  } else {
    const [activeLng, setActiveLng] = useState(i18next.resolvedLanguage)
    useEffect(() => {
      if (activeLng === i18next.resolvedLanguage) return
      setActiveLng(i18next.resolvedLanguage)
    }, [activeLng, i18next.resolvedLanguage])
    useEffect(() => {
      if (!locale || i18next.resolvedLanguage === locale) return
      i18next.changeLanguage(locale)
    }, [locale, i18next])
  }
  return useTranslation(ns, options)
}
